import React from 'react';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import styles from './ColorFieldRow.module.css';

function toColorInputValue(raw: string): string {
  const trimmed = raw.trim();
  if (/^#[0-9a-f]{6}$/i.test(trimmed)) return trimmed;
  if (/^#[0-9a-f]{3}$/i.test(trimmed)) {
    const redDigit = trimmed[1]!;
    const greenDigit = trimmed[2]!;
    const blueDigit = trimmed[3]!;
    return `#${redDigit}${redDigit}${greenDigit}${greenDigit}${blueDigit}${blueDigit}`.toUpperCase();
  }
  return '#000000';
}

export interface ColorFieldRowProps {
  label: string;
  colorValue: string;
  onColorValueChange: (value: string) => void;
  inputId: string;
}

export const ColorFieldRow: React.FC<ColorFieldRowProps> = ({
  label,
  colorValue,
  onColorValueChange,
  inputId,
}) => {
  const swatchBg = colorValue.trim() || '#e5e7eb';
  return (
    <div className={styles.row}>
      <Label htmlFor={inputId} className={styles.fieldLabel}>
        {label}
      </Label>
      <label className={styles.swatch}>
        <span aria-hidden style={{ backgroundColor: swatchBg }} />
        <input
          type="color"
          value={toColorInputValue(colorValue)}
          onChange={e => onColorValueChange(e.target.value)}
          title={`Pick ${label.toLowerCase()}`}
        />
      </label>
      <Input
        id={inputId}
        value={colorValue}
        onChange={e => onColorValueChange(e.target.value)}
        placeholder="#22c55e or named color"
        className={styles.colorHexInput}
      />
    </div>
  );
};
